export const formatMinutes = (totalMinutes) => {
  const totalMs = totalMinutes * 60 * 1000;
  const mins = Math.floor(totalMs / 60000);
  const secs = Math.floor((totalMs % 60000) / 1000);
  const ms = Math.floor((totalMs % 1000) / 10);
  const paddedMins = String(mins).padStart(2, "0");
  const paddedSecs = String(secs).padStart(2, "0");
  const paddedMs = String(ms).padStart(2, "0");

  return `${paddedMins}:${paddedSecs}:${paddedMs}`;
};

export const convertSeconds = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const ms = Math.floor((totalSeconds % 1) * 1000);

  return (
    [String(minutes).padStart(2, "0"), String(seconds).padStart(2, "0")].join(
      ":",
    ) + `.${String(ms).padStart(3, "0")}`
  );
};
